import { ReactLenis } from '@studio-freight/react-lenis'
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageContainer from './pages/PageContainer';
import Urunler from './pages/Urunler';
import Anasayfa from './pages/Anasayfa';
import Iletisim from './pages/Iletisim';
import Hakkimizda from './pages/Hakkimizda';
import UrunlerDetay from './pages/UrunlerDetay';
import Products from './pages/Products';



function App() {

  const location = useLocation();
  return (
    <ReactLenis root>
      <div className=" relative ">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageContainer />} >
            <Route path="/" element={<Anasayfa />} />

              <Route path="/urunler/:id1" element={<Urunler />} />
              <Route path="/urunler/:id1/:id2" element={<UrunlerDetay />} />


              <Route path="/products/:id1" element={<Products />} />
              <Route path="/products/:id1/:id2" element={<UrunlerDetay />} />



              <Route path="/iletisim" element={<Iletisim />} />
              <Route path="/hakkimizda" element={<Hakkimizda />} />








            </Route>
          
          </Routes>
        </AnimatePresence>
      </div>
    </ReactLenis>
  );
}

export default App;
